import File from 'Js/api/v1/model/File';

export default class Image extends File {
    constructor(
        {
            id,
            uri,
            thumbnailUri,
            description,
            used,
            alt,
            isMain,
            title,
            sources,
            thumbnailSources
        },
        blob
    ) {
        super(blob);
        this.id = id;
        this.uri = uri;
        this.thumbnailUri = thumbnailUri;
        this.timestamp = Date.now();
        this.description = description;
        // TODO: Garage перенести в PartImage
        this.used = used;
        this.alt = alt;
        this.isMain = isMain;
        this.title = title;
        this.srcSet = sources?.srcSet;
        this.sizes = sources?.sizes;
        this.thumbnailSrcSet = thumbnailSources?.srcSet;
        this.thumbnailSizes = thumbnailSources?.sizes;
    }

    /**
     * В будущем можно будет сделать фильтр по размеру,
     * если будем получать массив превьюшек
     */
    getThumbnail() {
        const { thumbnailUri } = this;

        return thumbnailUri
            ? new Image({
                  id: this.id,
                  uri: thumbnailUri,
                  thumbnailUri
              })
            : this;
    }

    createUri() {
        if (this.id == 0) {
            return super.createUri();
        } else {
            return this.uri;
        }
    }

    revokeUri() {
        if (this.id == 0) {
            super.revokeUri();
        }
    }

    valueOf() {
        return this.id;
    }

    toString() {
        return this.uri || '';
    }

    toJSON() {
        return this.id;
    }

    static stringifySrcSet(sources) {
        if (!sources || sources.length == 0) {
            return {};
        }
        const result = sources.reduce(
            (acc, img, index, array) => {
                const isLast = index === array.length - 1;
                acc.srcSet.push(`${img.Url} ${img.Descriptor}w`);
                acc.sizes.push(
                    !isLast
                        ? `(max-width: ${img.Descriptor}px) ${img.Descriptor}px`
                        : `${img.Descriptor}px`
                );

                return acc;
            },
            { srcSet: [], sizes: [] }
        );
        return {
            srcSet: result.srcSet.join(', '),
            sizes: result.sizes.join(', ')
        };
    }

    static parse(dto) {
        if (dto) {
            const {
                Id,
                Uri,
                ImageUri,
                ThumbnailUri,
                Description,
                Used,
                Alt,
                ImageGuid,
                IsMain,
                Title,
                SrcSet,
                ThumbnailSrcSet
            } = dto;
            return new Image({
                id: Id || ImageGuid,
                uri: Uri || ImageUri,
                thumbnailUri: ThumbnailUri,
                description: Description || null,
                used: Used,
                alt: Alt,
                isMain: IsMain,
                title: Title,
                sources: Image.stringifySrcSet(SrcSet),
                thumbnailSources: Image.stringifySrcSet(ThumbnailSrcSet)
            });
        } else return null;
    }

    static create(blob) {
        return new Image({ id: 0 }, blob);
    }
}
